angular.module('manufacturing')
    .controller('ManufacturingOrderLinkSelectController', function ($uibModalInstance, data, ManufacturingOrder, ManufacturingOrderService) {
        this.client = data.client
        this.statuses = ManufacturingOrderService.statuses()
        this.sameClientOnly = this.client != null
        this.filters = {page: 1, size: 10, sort: 'deliveryTime,desc', client: this.client && this.client.id, status: ['PENDING', 'CONFIRMED', 'IN_PROGRESS']}
        this.alreadySelectedIds = data.alreadySelectedIds || []

        this.$onInit = () => this.loadData()

        this.loadData = () => ManufacturingOrder.table(this.filters).$promise.then(result => this.items = result)
        this.applyFilters = () => {
            this.filters.page = 1
            return this.loadData()
        }
        this.onSameClientChanged = () => {
            this.filters.client = this.sameClientOnly ? this.client.id : null
            return this.applyFilters()
        }
        this.isAlreadySelected = id => this.alreadySelectedIds.includes(id)
        this.select = item => $uibModalInstance.close(item)
        this.cancel = () => $uibModalInstance.dismiss('cancel')
    })
